export { default } from './Tabs';
export type { TTabItem } from './Tabs';
export { default as TabPanel } from './TabPanel';
